<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
      <b-card>
        <h4 class="heading">
          {{ $t("PaymentMethods") }}
          <feather-icon
            id="export"
            icon="DownloadCloudIcon"
            svgClasses="w-5 h-5 hover:text-danger stroke-current"
            class="ml-5"
            :title="$t('Export')"
            @click="activePrompt = true"
            v-b-modal.modal-1
          />
        </h4>

        <b-button
          variant="primary"
          class="add border-primary"
          @click="openAddPopup"
          >{{ $t("Add") }}</b-button
        >

        <b-modal
          id="modal-1"
          :title="$t('ExportToExcel')"
          :ok-title="$t('Export')"
          :cancel-title="$t('Cancel')"
          @ok="exportToExcel"
          @cancel="clearFields"
          @close="clearFields"
          class="export-options"
          centered
        >
          <b-input
            v-model="fileName"
            :placeholder="$t('FileName')"
            :label="$t('FileName')"
            class="w-full"
          />
          <v-select v-model="selectedFormat" :options="formats" class="my-4"
            ><template v-slot:option="option">
              <span :class="option.icon">{{ option.label }} </span>
              <feather-icon
                v-if="selectedFormat == option.label"
                icon="CheckIcon"
                class="float-right"
                svgClasses="w-5 h-5"
              />
            </template>
          </v-select>
          <div class="flex walk-card">
            <span class="mr-4">{{ $t("CellAutoWidth") }}:</span>
            <b-form-checkbox
              v-model="cellAutoWidth"
              size="lg"
              name="cell_width"
              switch
            >
            </b-form-checkbox>
          </div>
        </b-modal>

        <!--  -->

        <div class="export-table mt-5">
          <b-col lg="5" class="my-1 p-2 float-right">
            <b-form-group
              label-for="filter-input"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-input-group size="md">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model="filter"
                  type="search"
                  :placeholder="$t('Search')"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          
          <b-table
            :current-page="currentPage"
            :per-page="perPage"
            :items="staffs"
            :fields="fields"
            :busy="isBusy"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            responsive
            show-empty
            :filter="filter"
            :filter-included-fields="filterOn"
            :empty-text="$t('EmptyData')"
            :empty-filtered-text="$t('EmptyFilter')"
            @filtered="onFiltered"
          >
            <template #head()="data">
              <span>{{ $t(data.label) }}</span>
            </template>

            <template #cell()="data">
              {{ data.value || "NA" }}
            </template>

            <template #cell(is_default)="row">
              <feather-icon
                v-if="row.item.is_default"
                v-b-tooltip.hover
                icon="CheckIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
              />
            </template>
            <template #cell(actions)="row">
              <feather-icon
                v-b-tooltip.hover
                :title="$t('Edit')"
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click="editCard(row.item)"
              />
              <feather-icon
                v-b-tooltip.hover
                :title="$t('Delete')"
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click="deleteCard(row.item.id, row.item.card_number_last_4)"
              />
              <feather-icon
                v-if="!row.item.is_default"
                v-b-tooltip.hover
                :title="$t('SetPaymentMethod')"
                icon="CheckCircleIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2 pull-left"
                @click="setCardIsDefault(row.item.id)"
              />
            </template>
          </b-table>

          <b-pagination
            v-if="rows > perPage"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="my-table"
            class="float-right"
          ></b-pagination>
        </div>
        <div class="centerx">
          <b-modal
            no-close-on-backdrop
            no-close-on-esc
            no-enforce-focus
            id="max-appointment-popup"
            :title="
              update_id == ''
                ? $t('AddPaymentMethod')
                : $t('UpdatePaymentMethod')
            "
            v-model="popupActivo"
            centered
            hide-footer
          >
            <div class="card-form__inner w-full">
              <div class="mt-2 m-2 p-2">
                <strong for="card-element">{{
                  $t("CreditorDebitCard")
                }}</strong>
                <div class="">
                  <span
                    class="dc_payment_icons_bevel_48 dc_visa02_bevel"
                    title="Visa"
                  ></span>
                  <span
                    class="dc_payment_icons_bevel_48 dc_mastercard_bevel"
                    title="Mastercard"
                  ></span>
                  <span
                    class="dc_payment_icons_bevel_48 dc_americanexpress_bevel"
                    title="American Express"
                  ></span>
                </div>
                <!-- <div id="card-element" class="mt-5"></div> -->
                <div class="card-form">
                  <div class="">
                    <div class="card-input">
                      <label for="cardNumber" class="card-input__label">
                        {{ $t("CardNumber") }}
                        <span class="float-right">
                          <feather-icon
                            icon="LockIcon"
                            svgClasses="h-6 w-6 stroke-current text-grey"
                            class="block"
                        /></span>
                      </label>
                      <b-input
                        v-validate="'required'"
                        :value="cardNumber"
                        autofocus
                        id="cardnumber"
                        name="cardnumber"
                        autocomplete="cc-number"
                        v-model="card"
                        :placeholder="$t('CardNumber')"
                        :data-vv-as="$t('CardNumber')"
                        @change="cardChange"
                        @input="cardInput"
                        onkeypress="return /[0-9]/i.test(event.key)"
                        maxlength="16"
                      />

                      <span id="card" class="text-danger text-sm"></span>
                    </div>

                    <div class="card-form__row">
                      <div class="card-form__col">
                        <div class="card-form__group">
                          <label for="cardMonth" class="card-input__label">
                            {{ $t("ExpirationDate") }}
                          </label>
                          <div
                            class="w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-2"
                          >
                            <v-select
                              v-validate="'required'"
                              size="large"
                              id="cardMonth"
                              v-model="month"
                              :options="months"
                              name="month"
                              :placeholder="$t('Month')"
                              class="w-full lg:pr-2 md:pr-2 xl:pr-2"
                              :data-vv-as="$t('Month')"
                              @input="monthChange"
                            >
                              <template v-slot:option="option">
                                <span :class="option.icon"
                                  >{{ option.label }}
                                </span>
                                <feather-icon
                                  v-if="month == option.label"
                                  icon="CheckIcon"
                                  class="float-right"
                                  svgClasses="w-5 h-5"
                                />
                              </template>
                            </v-select>

                            <span
                              id="monthExpire"
                              class="text-danger text-sm"
                            ></span>
                          </div>

                          <div
                            class="w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-2"
                          >
                            <v-select
                              size="large"
                              v-validate="'required'"
                              id="cardYear"
                              v-model="year"
                              :options="years"
                              name="year"
                              :placeholder="$t('Year')"
                              class="w-full lg:pl-2 md:pl-2 xl:pl-2"
                              :data-vv-as="$t('year')"
                              @input="yearChange"
                            >
                              <template v-slot:option="option">
                                <span :class="option.icon"
                                  >{{ option.label }}
                                </span>
                                <feather-icon
                                  v-if="year == option.label"
                                  icon="CheckIcon"
                                  class="float-right"
                                  svgClasses="w-5 h-5"
                                />
                              </template>
                            </v-select>
                            <span
                              id="yearExpire"
                              class="text-danger text-sm ml-2"
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div
                      class="w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2"
                    >
                      <div class="card-input ml-5">
                        <label for="cardCvv" class="card-input__label">
                          {{ $t("SecurityCode") }}
                          <span class="float-right">
                            <feather-icon
                              :title="$t('SecurityCode')"
                              icon="HelpCircleIcon"
                              svgClasses="h-6 w-6 stroke-current text-grey"
                              class="block" /></span
                        ></label>

                        <b-input
                          id="cardCvv"
                          name="cardCvv"
                          autocomplete="off"
                          v-model="cvv"
                          :placeholder="$t('SecurityCode')"
                          @change="cvvChange"
                          @input="cvvInput"
                          onkeypress="return /[0-9]/i.test(event.key)"
                          maxlength="3"
                        />
                        <span id="cvv" class="text-danger text-sm"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="vx-row align-text xs:w-full sm:w-full md:w-full lg:w-full xl:w-full ml-2"
                >
                  <div class="w-1/4"></div>
                  <div class="w-1/2">
                    <b-button
                      variant="primary"
                      @click="submit"
                      id="card-button"
                      class="mt-5"
                    >
                      <span>{{ text }}</span>
                    </b-button>
                    <div class="w-1/4"></div>
                  </div>
                </div>
              </div>
            </div>
          </b-modal>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import vSelect from "vue-select";
import $ from "jquery";
import { getStripeKey } from "@/utils/stripe";
import moment from "moment";
import { Validator } from "vee-validate";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      text: this.$t("AddPaymentMethod"),
      fileName: "",
      formats: ["xlsx", "csv", "txt"],
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: ["CardNumber", "ExpirationDate", "Default"],
      headerVal: [
        "first_name",
        "last_name",
        "email",
        "contact_number",
        "department_names",
      ],
      staffs: [],
      activePrompt: false,
      popupActivo: false,
      perPage: 10,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      isBusy: false,
      totalRows: 1,
      fields: [
        {
          key: "card_number_last_4",
          label: "CardNumber",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "expire_date",
          label: "ExpirationDate",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "is_default",
          label: "Default",
          sortable: true,
          sortDirection: "desc",
        },
        { key: "actions", label: "Action" },
      ],
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,

      card: "",
      cardNumber: "4242424242424242",
      month: "",
      year: "",
      name: "",
      cvv: "",
      card_id: "",
      cardLength: 0,
      toolText: "",
      todayDate: null,
      createdDate: null,
      diffDate: null,
      close: true,
      currentYear: new Date().getFullYear(),
      months: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      years: [],
      token: "",
      update_id: "",
    };
  },
  computed: {
    is_unio() {
      return this.$store.getters.currentUser.is_unio;
    },
    rows() {
      return this.staffs.length;
    },
  },
  created() {
    this.getCardList();
  },

  mounted() {
    var max = new Date().getFullYear();
    var min = max + 9;
    var years = [];

    for (var i = max; i <= min; i++) {
      years.push(i);
    }
    this.years = years;
    this.loadLocale(this.$i18n.locale);
    this.card_id = this.$store.getters.currentUser.card_id || "";

    this.cardLength = this.card_id.length;
    let id = this.$store.getters.currentUser.staff_id;
    id && this.getCompanyUsers(id);
  },

  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
      },
    },
  },

  methods: {
    getCompanyUsers($id) {
      this.show = true;
      this.$store
        .dispatch("showCompanyProfile", $id)
        .then((res) => {
          this.show = false;
          let { created_at } = res.data.data;
          this.createdDate = moment(created_at);

          this.todayDate = moment();
          this.diffDate = this.todayDate.diff(this.createdDate, "days");
          this.close = false;
          if (this.diffDate > 7) this.close = true;
        })
        .catch((error) => {
          this.$log.error(
            "File : PaymentMethods.vue | Function : getCompanyUsers() | Error :",
            error
          );
          console.log(error);
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    /**
     *  exportToExcel method for export file according to format
     **/
    exportToExcel() {
      import("@/assets/utils/export").then((excel) => {
        const list = this.staffs;
        this.headerTitle.map((title, index) => {
          this.headerTitle[index] = this.$t(title);
        });

        const data = this.formatJson(this.headerVal, list);
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat,
        });
        this.headerTitle = [
          "FirstName",
          "LastName",
          "Email",
          "Number",
          "Department",
        ];
        this.clearFields();
      });
    },
    /**
     *  @params filterVal ,jsonData
     * formatJson   method  for export file according to format
     **/
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
    /**
     *
     * clearFields   method  for export selected format
     **/
    clearFields() {
      this.fileName = "";
      this.cellAutoWidth = true;
      this.selectedFormat = "xlsx";
    },

    /**
     *
     * getCardList   method  for list all staffs data
     **/
    getCardList() {
      this.success = "";
      this.error = "";
      this.show = true;

      this.$store
        .dispatch("GetCardList", this.$store.getters.currentUser.id)
        .then((res) => {
          this.show = false;
          this.staffs = res.data.data;
          this.totalRows = this.staffs.length;
        })
        .catch((error) => {
          this.$log.error(
            "File : PaymentMethods.vue | Function : getCardList() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     *
     * deleteCard   method  for delete  card from listing
     **/
    deleteCard(id, card_id) {
      this.success = "";
      this.error = "";
      this.$swal({
        title: this.$t("DeleteCardConfirmationMessage") + "  \n" + card_id,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes"),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t("No"),
        showCloseButton: true,
        showLoaderOnConfirm: true,
      })
        .then((result) => {
          if (result.value) {
            this.show = true;
            this.$store.dispatch("DeleteCardDetail", id).then((res) => {
              this.show = false;
              this.getCardList();
              this.success = this.$t("CardDeleteSuccess");
              this.$toasted.show(this.success, {
                className: "top-alert",
                position: "top-center",
                type: "success",
                duration: 2000,
              });
            });
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : PaymentMethods.vue | Function : deleteCard() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    /**
     * open popup
     */
    openAddPopup() {
      this.text = this.$t("AddPaymentMethod");
      this.$validator.reset();
      this.update_id = "";
      this.card = "";
      this.month = "";
      this.year = "";
      this.cvv = "";
      this.popupActivo = true;
    },

    cardInput() {
      let card = Stripe.card.validateCardNumber(this.card);
      if (this.card == "") {
        $("#card").text(this.$t("CardRequired"));
        return false;
      } else {
        $("#card").text("");
      }
    },
    cardChange() {
      let card = Stripe.card.validateCardNumber(this.card);
      if (this.card == "") {
        $("#card").text(this.$t("CardRequired"));
        return false;
      } else {
        $("#card").text("");
      }
    },
    cvvInput() {
      let card = Stripe.card.validateCVC(this.cvv);
      if (this.cvv == "") {
        $("#cvv").text(this.$t("SecurityCodeRequired"));
        return false;
      } else {
        $("#cvv").text("");
      }
    },
    cvvChange() {
      let card = Stripe.card.validateCVC(this.cvv);
      if (this.cvv == "") {
        $("#cvv").text(this.$t("SecurityCodeRequired"));
        return false;
      } else {
        $("#cvv").text("");
      }
    },
    monthChange() {
      if (this.month == "" || this.month == null) {
        $("#monthExpire").text(this.$t("MonthRequired"));
      } else {
        $("#monthExpire").text("");
      }
    },
    yearChange() {
      if (this.year == "" || this.year == null) {
        $("#yearExpire").text(this.$t("YearRequired"));
      } else {
        $("#yearExpire").text("");
      }
    },

    /**
     * saveCard
     */
    saveCard(card_id) {
      this.$vs.loading();
      if (card_id) {
        var data = {
          update_id: this.update_id,
          card_id: card_id,
          company_id: this.$store.getters.currentUser.id,
          card_number: this.card,
          month: this.month,
          year: this.year,
        };
        var action =
          this.update_id != "" ? "UpdateCardDetail" : "AddCardDetail";
        this.$store
          .dispatch(action, data)
          .then((res) => {
            this.popupActivo = false;
            this.getCardList();
            this.$vs.loading.close();
            var msg =
              this.update_id != "" ? "CardUpdatedSuccess" : "CardAddedSuccess";
            this.$vs.notify({
              title: this.$t("Success"),
              text: this.$t(msg),
              color: "success",
              position: "top-center",
            });
            if (this.upgradePlan) this.cardAdded = true;
          })
          .catch((error) => {
            this.$vs.loading.close();
            console.log("SaveCard-error", error);
            // Error response
            this.$vs.notify({
              title: this.$t("CardFailed"),
              text: error,
              color: "danger",
              position: "top-center",
            });
            return false;
          });
      }
    },

    submit() {
      if (this.cvv == "") {
        $("#cvv").text(this.$t("SecurityCodeRequired"));
      }
      if (this.card == "") {
        $("#card").text(this.$t("CardRequired"));
      } else {
        $("#card").text("");
      }
      if (this.month == "") {
        $("#monthExpire").text(this.$t("MonthRequired"));
      } else {
        $("#monthExpire").text("");
      }
      if (this.year == "") {
        $("#yearExpire").text(this.$t("YearRequired"));
      } else {
        $("#yearExpire").text("");
      }
      if (this.card && this.month && this.year && this.cvv) {
        let card = Stripe.card.validateCardNumber(this.card);
        let cvv = Stripe.card.validateCVC(this.cvv);
        let expiry = Stripe.card.validateExpiry(this.month, this.year);

        if (card !== true) {
          $("#card").text(this.$t("CardInvalid"));
          return false;
        }
        if (cvv !== true) {
          $("#cvv").text(this.$t("CvvInvalid"));
          return false;
        }
      } else {
        return false;
      }

      let instance = this;
      function stripeResponseHandler(status, response) {
        // Grab the form:
        console.log("status-----", status);
        console.log("response-----", response);

        if (response.error) {
          if (response.error.code == "incorrect_number") {
            $("#card").text(this.$t("CardIncorrect"));
            return false;
          }
          if (response.error.code == "card_declined") {
            $("#card").text(this.$t("CardDeclined"));
            return false;
          }

          // Problem!
          if (response.error.code == "invalid_expiry_month") {
            $("#monthExpire").text(this.$t("ExpireMonth"));
            return false;
          }
          if (response.error.code == "invalid_expiry_year") {
            $("#yearExpire").text(this.$t("ExpireYear"));
            return false;
          }
          if (
            response.error.code == "parameter_missing" &&
            response.error.param == "card[exp_month]"
          ) {
            $("#monthExpire").text(this.$t("MonthRequired"));
          }
          if (
            response.error.code == "parameter_missing" &&
            response.error.param == "card[exp_year]"
          ) {
            $("#yearExpire").text(this.$t("YearRequired"));
          }
          console.log("response.error-----------", response.error);
          return false;
        } else {
          // Token was created!

          // Get the token ID:
          instance.token = response.id;
          if (instance.token) this.saveCard(instance.token);
        }
      }

      Stripe.setPublishableKey(getStripeKey());
      Stripe.card.createToken(
        {
          number: this.card,
          cvc: this.cvv,
          exp_month: this.month,
          exp_year: this.year,
        },
        stripeResponseHandler.bind(this)
      );
    },

    editCard(data) {
      this.text = this.$t("EditPaymentMethod");
      this.update_id = data.id;
      this.card = data.card_number;
      this.month = data.expire_month;
      this.year = data.expire_year;
      this.popupActivo = true;
    },

    setCardIsDefault(id) {
      this.show = true;
      var data = {
        id: id,
        company_id: this.$store.getters.currentUser.id,
      };
      this.$store.dispatch("SetCardIsDefault", data).then((res) => {
        this.show = false;
        this.getCardList();
        this.success = this.$t("CardDeleteSuccess");
        this.$toasted.show(this.success, {
          className: "top-alert",
          position: "top-center",
          type: "success",
          duration: 2000,
        });
      });
    },
  },
};
</script>

<style lang="stylus" scope>
.heading {
  margin-bottom: 20px;
}

.add {
  position: absolute;
  margin-top: 10px;
}

.action {
  margin-left: 20px;
  display: inline;
}

.con-vs-tooltip {
  display: inline;
}
</style>

<style scoped lang="scss">
a {
  text-decoration: underline !important;
}
.card-container {
  margin: 30px auto 50px auto;
}
#card-button {
  white-space: nowrap;
}
.vx-row {
  margin-top: 10px !important;
}

.card-form {
  max-width: 570px;
  margin: auto;
  width: 100%;

  &__inner {
    background: #fff;
    box-shadow: 0 30px 60px 0 rgba(90, 116, 148, 0.4);
    border-radius: 10px;
    padding: 20px;
  }

  &__row {
    display: flex;
    align-items: flex-start;
  }

  &__col {
    flex: auto;
    margin-right: 15px;

    &:last-child {
      margin-right: 0;
    }

    &.-cvv {
      max-width: 150px;
    }
  }

  &__group {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;

    .card-input__input {
      flex: 1;
      margin-right: 15px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__button {
    width: 100%;
    height: 55px;
    background: #38a294;
    border: none;
    border-radius: 5px;
    font-size: 22px;
    font-weight: 500;
    box-shadow: 3px 10px 20px 0px rgba(35, 100, 210, 0.3);
    color: #fff;
    margin-top: 20px;
    cursor: pointer;

    &:hover {
      background: darken(#38a294, 5%);
    }
  }
}

.card-input {
  margin-bottom: 20px;
  &__label {
    margin-bottom: 5px;
    color: #1a3b5d;
    width: 100%;
    display: block;
    text-align: left;
  }
  &__input {
    width: 100%;
    height: 50px;
    border-radius: 5px;
    box-shadow: none;
    border: 1px solid #ced6e0;
    transition: all 0.3s ease-in-out;
    font-size: 18px;
    padding: 5px 15px;
    background: none;
    color: #1a3b5d;

    &:hover,
    &:focus {
      border-color: #38a294;
    }

    &:focus {
      box-shadow: 0px 10px 20px -13px rgba(32, 56, 117, 0.35);
    }
    &.-select {
      -webkit-appearance: none;
      background-image: url("/img/select.png");
      background-size: 12px;
      background-position: 90% center;
      background-repeat: no-repeat;
      padding-right: 30px;
    }
    #subscription {
      text-align: justify !important;
    }
  }
}
.back-color {
  background-color: rgb(170, 247, 219);
}
.pull-left {
  float: left;
}
</style>  